import React from "react";
import { Box } from "@mui/material";
import { Navigate } from "react-router-dom";
import { useAuthState } from "react-firebase-hooks/auth";
import LandingCareStoryHome from "../components/Landing/LandingCareStoryHome";
import { landingPageStyles } from "../assets/theme/landingTheme";
import { auth } from "../services/firebase";

const LandingPage = () => {
  const [currentUser, authLoading] = useAuthState(auth);

  if (!authLoading && currentUser) {
    return <Navigate to="/home" replace />;
  }

  return (
    <Box sx={landingPageStyles} data-cy="landing-page">
      <LandingCareStoryHome />
    </Box>
  );
};

export default LandingPage;
